<div class="similar-products">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.lt-lg="90%">
            <h2 class="title">Productos Relacionados</h2>
            <hr>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.xs="100%" fxFlex.sm="90%" fxFlex.md="90%">
            <app-product-card></app-product-card>
            <app-product-card></app-product-card>
            <app-product-card></app-product-card>
            <app-product-card fxHide></app-product-card>
        </div>
    </div>
</div>